function addActiveCssClassToActiveMenuItem() {
  const url = window.location;
  const activeItem = document.querySelector(
    'nav.ma-AccountNav > ul > li.ma-AccountNav-item > a[href="' + url.href + '"]'
  );
  if (activeItem !== null && activeItem !== undefined) {
    activeItem.parentElement.setAttribute('active', 'true');
    activeItem.setAttribute('active', 'true');
  }
  switch (window.location.pathname) {
    case '/account/order/resale':
      document.getElementById('order').parentElement.setAttribute('active', 'false');
      document.getElementById('order').setAttribute('active', 'false');
      break;
    case '/account/dashboard':
      document.getElementById('dashboard').parentElement.setAttribute('active', 'true');
      document.getElementById('dashboard').setAttribute('active', 'true');
      break;
    case window.location.pathname.match(/\/MyAccount\/Membership(.*)/i)?.input:
    case '/account/subscriptions/fnacviedigitale':
    case '/account/subscriptions/fnacetmoi':
    case '/account/subscriptions/membership':
      document.getElementById('member').parentElement.setAttribute('active', 'true');
      document.getElementById('member').setAttribute('active', 'true');
      break;
    case '/account/personal-information':
    case '/account/personalinfos/address-book':
    case window.location.pathname.match(/\/account\/address-book(.*)/)?.input:
    case window.location.pathname.match(/\/account\/update-password(.*)/)?.input:
    case '/account/payment-methods':
    case '/account/newsletter':
      document.getElementById('personal').parentElement.setAttribute('active', 'true');
      document.getElementById('personal').setAttribute('active', 'true');
      break;
    case '/MyAccount/Order':
    case window.location.pathname.match(/\/account\/order(.*)/)?.input:
    case '/account/orders':
    case '/account/ebooks':
    case window.location.pathname.match(/\/Account\/Incident(.*)/)?.input:
    case window.location.pathname.match(/\/Account\/Profil\/AddressOrderDetail.aspx(.*)/)?.input:
    case window.location.pathname.match(/\/MyAccount\/Order(.*)/)?.input:
    case '/Account/OrderCCV/CCVAccount.aspx':
    case '/account/Incident/Historic':
      document.getElementById('order').parentElement.setAttribute('active', 'true');
      document.getElementById('order').setAttribute('active', 'true');
      break;
    case window.location.pathname.match(/\/account\/wishlist(.*)/i)?.input:
      document.getElementById('wishlist').parentElement.setAttribute('active', 'true');
      document.getElementById('wishlist').setAttribute('active', 'true');
      break;
    case '/account/alerting':
      document.getElementById('alert').parentElement.setAttribute('active', 'true');
      document.getElementById('alert').setAttribute('active', 'true');
      break;
    case '/account/synchro-deezer':
      document.getElementById('partner').parentElement.setAttribute('active', 'true');
      document.getElementById('partner').setAttribute('active', 'true');
      break;
    case '/account/quotes/':
      document.getElementById('devis').parentElement.setAttribute('active', 'true');
      document.getElementById('devis').setAttribute('active', 'true');
      break;
    case '/account/chatbot':
      document.getElementById('chatbot').parentElement.setAttribute('active', 'true');
      document.getElementById('chatbot').setAttribute('active', 'true');
      break;
  }
}

document.addEventListener('DOMContentLoaded', addActiveCssClassToActiveMenuItem);
